import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { HttpService } from '../../../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root',
})
export class ConsultaArquivosImportacaoFuncionariosService {

  constructor( private httpService: HttpService) { }


  searchImportFiles(data: any, successHandle: Function, errorHandle: Function) {

    this.httpService.doGet('/employee/batch', data, successHandle, errorHandle);

 }


 searchFileImportEmployeeStatus(data: any, successHandle: Function, errorHandle: Function) {

  this.httpService.doGet('/employee/batch/status', data, successHandle, errorHandle);

}
}
